const userNameClaim =
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name";
const rolesClaim =
    "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
const emailClaim =
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/email";
const userIdClaim =
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier";

export const IdentityClaims = {
    userNameClaim,
    rolesClaim,
    emailClaim,
    userIdClaim,
};

export const RequestHeaders = {
    HotelId: "x-hotel-id",
    TenantId: "x-tenant-id",
    Currency: "x-currency"
}

export const TenantRoles = {
    Admin: "aa9b5bdb-4cbf-4ec5-84e2-f848aae56710", 
    Owner: "2df33ba1-431c-4c47-a8af-d5a443c5ff99" 
};

export enum Roles {
    superAdmin = "SuperAdmin",
    admin = "Admin",
    owner = "Owner",
}

type UserDetails = {
    email: string;
    phoneNumber?: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
};

type IdentityUserTenantRole = {
    tenantId: string;
    role: Roles;
}

type IdentityUser = {
    userName: string;
    avatarUrl?: string;
    roles: IdentityUserTenantRole[];
};

type LoginRequestDto = {
    userName: string;
    password: string;
};

type Claims = {
    aud: string | string[];
    exp: number;
    iss: string;
    sub: string;
    email?: string;
    preferred_username?: string;
    realm_access?: {
        roles: string[];
    };
};

type TokensResponseDto = {
    accessToken: string;
    refreshToken: string;
    accessTokenExpires: Date;
    refreshTokenExpires: Date;
}

type LoginResponseDto = {
    tokens: TokensResponseDto;
    user: MyInformationResponseDto;
    passwordChangeRequired?: boolean;
    migrationToken?: string;
};

type CompleteMigrationRequestDto = {
    token: string;
    newPassword: string;
};

type RefreshTokenRequestDto = {
    refreshToken: string;
};

type TwoFactorAuthResponseDto = {
    token: string;
    twoFactorRequired: boolean;
}

type LoginTwoFactorRequestDto = {
    token: string;
    code: string;
}

type RegisterUserRequestDto = {
    userName: string;
    email: string;
    phoneNumber?: string;
    password: string;
    firstName?: string;
    lastName?: string;
    country?: string;
};

type ConfirmSecurityCodeRequestDto = {
    confirmationToken: string;
    code: string;
};

type MyTenantRoleDto = {
    tenantId: string;
    role: string;
};

type MyInformationResponseDto = {
    id: string;
    userName: string;
    email: string;
    phoneNumber?: string;
    fullName?: string;
    avatarUrl?: string;
    tenantRoles: MyTenantRoleDto[];
};

type DoRequestPreTokenRequestDto = {
    userName: string;
    password: string;
}

type DoRequestTokenRequestDto = {
    userName: string;
    password: string;
    returnUrl?: string;
}

type TenantDto = {
    id: string;
    name: string;
    description: string;
    logoUrl?: string;
}

export type {
    IdentityUser,
    UserDetails,
    Claims,
    LoginResponseDto,
    CompleteMigrationRequestDto,
    RefreshTokenRequestDto,
    RegisterUserRequestDto,
    ConfirmSecurityCodeRequestDto,
    LoginRequestDto,
    MyInformationResponseDto,
    MyTenantRoleDto,
    DoRequestTokenRequestDto,
    DoRequestPreTokenRequestDto,
    TenantDto,
    TokensResponseDto,
    TwoFactorAuthResponseDto,
    LoginTwoFactorRequestDto,
    IdentityUserTenantRole
};